<script setup>
/**
 * Collapse 折叠面板
 *
 * @prop {String|Array} modelValue 当前激活的折叠面板，支持 String 和 Array
 * @prop {Boolean} accordion 是否开启手风琴模式
 * @prop {Boolean} disabled 是否禁用组件
 *
 * @slot default  CollapseContent 和 CollapseTrigger 组件
 *
 * @example
 * <Collapse v-model="activeName" accordion>
 *   <CollapseTrigger name="1">Trigger 1</CollapseTrigger>
 *   <CollapseContent name="1">Content 1</CollapseContent>
 *   <CollapseTrigger name="2">Trigger 2</CollapseTrigger>
 *   <CollapseContent name="2">Content 2</CollapseContent>
 * </Collapse>
 *
 * CollapseTrigger / CollapseContent
 *
 * @prop {String} tag 设置标签元素，默认为 div
 * @prop {String|Number} name 唯一标识
 *
 */
const props = defineProps({
  modelValue: {
    type: [String, Array],
    default: () => []
  },
  accordion: Boolean,
  disabled: Boolean
})

const emit = defineEmits(['update:modelValue'])

const activeNames = computed({
  get: () => props.modelValue,
  set: (value) => emit('update:modelValue', value)
})

const handleItemClick = (name) => {
  if (props.disabled) return

  if (props.accordion) {
    activeNames.value = activeNames.value === name ? null : name
  } else {
    const names = Array.isArray(activeNames.value) ? [...activeNames.value] : []
    const index = names.indexOf(name)
    index > -1 ? names.splice(index, 1) : names.push(name)
    activeNames.value = names
  }
}

provide('collapse', {
  activeNames,
  handleItemClick
})
</script>

<template>
  <div class="collapse">
    <slot />
  </div>
</template>

<style lang="less">
.collapse {
  &--disabled > .collapse-trigger {
    cursor: not-allowed;
  }
}
</style>
